module.exports = __webpack_public_path__ + "static/media/4.313fb19e.svg";